import { getDefaultExportFromCjs as n } from "../../_virtual/_commonjsHelpers.js";
function d(e) {
  return e === void 0;
}
var i = d;
const f = /* @__PURE__ */ n(i);
export {
  f as default
};
//# sourceMappingURL=isUndefined.js.map
